export default __webpack_public_path__ + "static/WBTC-a26155f3092d212adeab884965194b28.jpg";